import {
  Theme,
  border2,
  inputElementStyles,
  optionStyles,
  rem,
  spacing,
  radius,
  nav,
  token,
} from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';
import { tagName } from '../../helpers';

export const tag = tagName('feedback-text-input');
export const theme = new Theme(tag);

export const styles = [
  optionStyles,
  css`
    :host {
      align-items: normal;
      display: flex;
      flex-direction: column;
      row-gap: ${spacing(50)};
    }

    .input-wrapper {
      box-sizing: border-box;
      display: inline-block;
      inline-size: 100%;
      position: relative;
    }

    :where(textarea) {
      ${inputElementStyles};
      background-color: ${token('background-secondary')};
      border-radius: ${radius('large')};
      box-sizing: border-box;
      color: ${token('input-foreground-default')};
      display: block;
      inline-size: 100%;
      min-block-size: ${rem(36)};
      overflow-y: hidden;
      /* TODO: no matching spacing token for 42px, 18px */
      padding: ${rem(8, 42, 8, 18)};
      resize: none;
      ${nav('medium')};
    }

    textarea::placeholder {
      color: ${token('input-foreground-placeholder')};
    }

    :where(a-loader, a-icon) {
      color: ${token('input-foreground-default')};
      inset-block-end: ${rem(18)};
      inset-inline-end: ${rem(20)};
      position: absolute;
      transform: translateY(50%);
    }

    :where(a-icon:hover) {
      cursor: pointer;
    }

    :host([disabled]) {
      :where(textarea) {
        background: ${token('input-background-disabled')};
        border: ${border2(1, 'input-border-disabled')};
        color: ${token('input-foreground-disabled')};
        cursor: not-allowed;
      }
      :where(textarea)::placeholder {
        color: ${token('input-foreground-disabled')};
      }
      :where(a-icon) {
        color: ${token('input-foreground-disabled')};
      }
    }
  `,
];
